import { WARM_DASHBOARD_API_BASE } from "./apiEndpoints";

export default function CheckUserPlanService(email) {
  const options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email }),
  };

  return fetch(
    `${WARM_DASHBOARD_API_BASE}/checkUserPlanService`,
    options
  );
}
  